// 求人情報の登録・編集共通
$(function () {
	$('.main.mypage.salon.job-offers [name="recruiting_personnel"]:radio').change(function () {
		$('.main.mypage.salon.job-offers [name="recruiting_personnel"]:radio').removeClass("active");
		$('.main.mypage.salon.job-offers select.select-hourly-pay').prop('disabled', true);
		$('.main.mypage.salon.job-offers input.input-other').prop('disabled', true);
		if ($(this).prop('checked')) {
			$(this).addClass("active");
			$(this).parent().find('select.select-hourly-pay').prop('disabled', false);
			$(this).parent().find('input.input-other').prop('disabled', false);
		}
	});
});

$(function () {
	$('.main.mypage.salon.job-offers [name="Application-Date"]:radio').change(function () {
		$('.main.mypage.salon.job-offers [name="Application-Date"]:radio').removeClass("active");
		$('.main.mypage.salon.job-offers .day-box').removeClass("day-box-active");
		$('.main.mypage.salon.job-offers .day-box input.select-day').prop('disabled', true);
		$('.main.mypage.salon.job-offers .day-box select.select-icon').prop('disabled', true);
		// $('.main.mypage.salon.job-offers .day-box .week li .week-select').prop('disabled', true);
		// $('.main.mypage.salon.job-offers select.select-icon').prop('disabled', true);
		$('.main.mypage.salon.job-offers input.week-select').prop('disabled', true);
        $('.chack-box').removeClass('day-box-active');
        $('.one-day').removeClass('active');
        $('.one-day').prop('disabled', true);
		if ($(this).prop('checked')) {
			var $parent = $(this).closest('.radio-box');
            $parent.closest('.items-center').find('.chack-box').addClass('day-box-active');
            $parent.closest('.items-center').find('.one-day').addClass('active');
            $parent.closest('.items-center').find('.one-day').prop('disabled', false);
			$(this).addClass("active");
			$parent.next().addClass('day-box-active');
			$('.day-box-active').find('input.select-day').prop('disabled', false);
			$('.day-box-active').find('select.select-icon').prop('disabled', false);
			$('.day-box-active').next('.week').find('li input.week-select').prop('disabled', false);
			$(this).parent().find('select.select-icon').prop('disabled', false);
			// $(this).parent().find('input.week-select').prop('disabled', false);
		}
	});
});

//求人の編集でcheckされているセレクトを有効化
$(function () {
	$('input[name="recruiting_personnel"]:checked').parent().find('select.select-hourly-pay').prop('disabled', false);
});

$(function() {
    $('[name="flg_travel_cost"]').click(function(){
        var num = $('input[name="flg_travel_cost"]:checked').val();
        if ( num == 1 ){
            $("#travel_cost").removeAttr("disabled");
        } else {
            $("#travel_cost").attr("disabled", "disabled");
        }
    });
});
